import React from 'react';
import AppRouter from './AppRouter';
import { useMsal, useAccount, MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import './App.css';
import { Typography } from '@mui/material';
import Service from './util/Service';
import useAzureConfig from './components/common/useAzureConfig';
import { ShowWait } from './components/home/Home';

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

function App() {
    const [config, ok, erro] = useAzureConfig();

    if (!config?.auth && ok === false) return(
        <ShowWait />
    );

    if( ok && !config?.auth){
        return (
            <AppRouter />
        )
    }
    // MSAL configuration
    const configuration = {
        auth: config.auth,
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: isIE || isEdge || isFirefox,
        },
    };

    const pca = new PublicClientApplication(configuration);
    return (
        <MsalProvider instance={pca}>
            <AppRouter />
        </MsalProvider>
    );

}

export default App;

